import React, { useState } from 'react';
import { projects } from '../mock';
import { Button } from './ui/button';

const Projects = () => {
  const [filter, setFilter] = useState('all');

  const categories = ['all', 'Regularização', 'Projetos', 'Desdobro', 'Averbação'];

  const filteredProjects = filter === 'all'
    ? projects
    : projects.filter((project) => project.category === filter);

  return (
    <section id="projects" className="py-20 px-4" style={{ backgroundColor: '#f8f9fa' }}>
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: '#1e3a5f' }}>
            Portfólio de Projetos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Conheça alguns dos projetos realizados com excelência e profissionalismo
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <Button
              key={category}
              onClick={() => setFilter(category)}
              variant={filter === category ? 'default' : 'outline'}
              className="px-6 py-2 font-semibold transition-all duration-200"
              style={{
                backgroundColor: filter === category ? '#1e3a5f' : 'transparent',
                color: filter === category ? 'white' : '#1e3a5f',
                borderColor: '#1e3a5f'
              }}
            >
              {category === 'all' ? 'Todos' : category}
            </Button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project) => (
            <div
              key={project.id}
              className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4">
                  <span
                    className="px-4 py-2 rounded-full text-sm font-semibold text-white"
                    style={{ backgroundColor: '#c17835' }}
                  >
                    {project.category}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-2" style={{ color: '#1e3a5f' }}>
                  {project.title}
                </h3>
                <p className="text-gray-600">
                  {project.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;